"use strict";
/*-----------------------------------------------------------------|
 * Contains the types which are persisted in the chosen storage.
 *----------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
